"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Tabs_1 = __importDefault(require("@material-ui/core/Tabs"));
const Tab_1 = __importDefault(require("@material-ui/core/Tab"));
const styles_1 = require("@material-ui/core/styles");
const silica_1 = require("@opendoor/silica");
const OpendoorLogoSvg_1 = __importDefault(require("../OpendoorLogoSvg/OpendoorLogoSvg"));
const zIndex_1 = __importDefault(require("@material-ui/core/styles/zIndex"));
const useTabsStyles = styles_1.makeStyles(() => styles_1.createStyles({
    indicator: {
        backgroundColor: silica_1.colors.gray6,
    },
}));
const useTabStyles = styles_1.makeStyles(() => styles_1.createStyles({
    textColorInherit: {
        '&.Mui-selected': {
            color: silica_1.colors.gray6,
        },
    },
}));
/**
 * Used to render the navigation bar at the top of the page, including:
 * - App Name
 * - Horizontal tabs representing the primary navigation links for the app
 * - Ability to render arbitrary content in a panel on the right side, often used to
 *   show info about the currently logged-in user and/or a logout button.
 */
const PrimaryNavigationBar = ({ links, renderPanel, isPanelConstrained = true, hasShadow, enableFixedPosition = false, }) => {
    const tabsStyles = useTabsStyles();
    const tabStyles = useTabStyles();
    if (!(links && links.length)) {
        return react_1.default.createElement("div", null);
    }
    let selectedIndex = links.findIndex((link) => link.isActive);
    const { href, onClick, title } = links[0];
    let appLinkClass = 'inline-flex items-center no-underline h-100% fs-6 black';
    const appLink = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("a", { href: href, onClick: onClick, className: appLinkClass },
            react_1.default.createElement(OpendoorLogoSvg_1.default, { className: "w-2 h-2 mr-4 inline-block" }),
            title),
        links.length > 1 && react_1.default.createElement("div", { className: "pl-6 mr-3 h-3 bor-2 bo-gray2 self-center" })));
    return (react_1.default.createElement("div", { className: [
            'flex-none flex items-end pl-6 h-5 b',
            hasShadow ? 'shadow-1 ' : 'bo-gray2 bob-2',
            enableFixedPosition ? 'fixed bg-white w-100%' : '',
        ].join(' '), style: { zIndex: zIndex_1.default.appBar } },
        appLink,
        !!(links && links.length > 1) && (react_1.default.createElement(Tabs_1.default, { classes: tabsStyles, className: "h-100% b", value: selectedIndex >= 1 ? selectedIndex : false }, links.map(({ href, onClick, title, component, componentProps }, index) => {
            if (index === 0) {
                return '';
            }
            return (react_1.default.createElement(Tab_1.default, Object.assign({ classes: tabStyles, key: index, value: index, href: href || '#', onClick: onClick, label: title, component: component }, componentProps)));
        }))),
        react_1.default.createElement("div", { className: [
                'ml-auto ',
                isPanelConstrained ? 'pv-5 pr-6' : 'flex-grow-1 h-100% overflow-x-hidden',
            ].join(' ') }, renderPanel && renderPanel())));
};
exports.default = PrimaryNavigationBar;
